// 快递物流跟踪跳转第三方服务

import LogisticsCompany from "@/enum/LogisticsCompany";
import { sample } from "lodash";
import LogisticsCompanyKuaiDi100CodeMap from "./LogisticsCompanyKuaiDi100CodeMap";

export enum TrackingWaybillType {
    /**
     * 从有效的随机选择一个
     */
    RANDOM = "RANDOM",

    /**官方 */
    OFFICIAL = "OFFICIAL",

    /**快递100 */
    KD100 = "KD100",

    /**百度 */
    BAIDU = "BAIDU",

    /**搜狗 */
    SOGOU = "SOGOU",
}

export const TrackingWaybillTypeNameMapping = {
    [TrackingWaybillType.RANDOM]: "随机网站",
    [TrackingWaybillType.OFFICIAL]: "快递官网",
    [TrackingWaybillType.KD100]: "快递100",
    [TrackingWaybillType.BAIDU]: "百度",
    [TrackingWaybillType.SOGOU]: "搜狗",
};

type UrlBuilder = (waybillNo: string) => string | undefined;

type TrackingWaybillBuilder = TrackingWaybillUrlBuilder;

interface TrackingWaybillUrlBuilder {
    type:
        | TrackingWaybillType.OFFICIAL
        | TrackingWaybillType.KD100
        | TrackingWaybillType.BAIDU
        | TrackingWaybillType.SOGOU;

    builder: UrlBuilder;
}

/**
 * 索引
 */
type LogisticsCompanyTrackingBuilderMapType = {
    [key in LogisticsCompany]?: TrackingWaybillBuilder[];
};

let init = false;
const LogisticsCompanyTrackingBuilderMap: LogisticsCompanyTrackingBuilderMapType = {};

function generateOfficialBuilder(logisticsCompany: LogisticsCompany): UrlBuilder {
    switch (logisticsCompany) {
        case LogisticsCompany.YTO:
            return (waybillNo) => `https://www.yto.net.cn/ytoExpress/waybill/waybillDetail/?mailNo=${waybillNo}`;

        case LogisticsCompany.HTKY:
            return (waybillNo) => {
                if (waybillNo.startsWith("JT")) {
                    return `https://www.jtexpress.com.cn/service.html?indexIpt=${waybillNo}`;
                }

                return null;
            };

        case LogisticsCompany.JT:
            return (waybillNo) => `https://www.jtexpress.com.cn/service.html?indexIpt=${waybillNo}`;

        case LogisticsCompany.YUNDA:
        case LogisticsCompany.YUNDA_TC:
        case LogisticsCompany.YUNDA56:
        case LogisticsCompany.YUNDA_DTD:
            return (waybillNo) => `https://web.yundaex.com/infoInquiry?nav_id=262&cid=0&homeWaybill=${waybillNo}`;

        case LogisticsCompany.YUNDAGJ:
            return (waybillNo) => `http://www.udalogistic.com/tracking?trackingNo=${waybillNo}`;

        case LogisticsCompany.SF:
        case LogisticsCompany.SFKY:
            return (waybillNo) => `https://www.sf-express.com/we/ow/chn/sc/waybill/waybill-detail/${waybillNo}`;

        case LogisticsCompany.ZY:
            return (waybillNo) => `https://zhongyouex.com/business?searchVal=${waybillNo}`;

        case LogisticsCompany.JD_EXPRESS:
        case LogisticsCompany.JD_HPCP:
        case LogisticsCompany.JDKY:
            return (waybillNo) => `https://www.jdl.com/orderSearch?waybillCodes=${waybillNo}`;

        case LogisticsCompany.FENGWANG:
            return (waybillNo) => `https://www.fwx-network.com/query/waybill/?waybill=${waybillNo}`;
        case LogisticsCompany.DBKD:
        case LogisticsCompany.DBL:
            return (waybillNo) => `https://www.deppon.com/track/ordertrack?orderNumList=%5B%22${waybillNo}%22%5D`;
        case LogisticsCompany.KUAYUE:
            return (waybillNo) => `https://u.ky-express.com/diyService/serviceOrderLoc?orders=${waybillNo}`;
        case LogisticsCompany.EXFRESH:
            return (waybillNo) => `http://dcsopenweb.exfresh.com.cn/#/track?billNo=${waybillNo}`;
        case LogisticsCompany.UC:
            return (waybillNo) => `https://www.uce.cn/business/expressInquiry?waybilllist=${waybillNo}`;
        case LogisticsCompany.SUT56:
            return (waybillNo) => `https://www.sut56.com/service-query?no=${waybillNo}`;
        case LogisticsCompany.AIR:
            return (waybillNo) => `http://www.airfex.net/track.aspx?o=${waybillNo}`;
        case LogisticsCompany.FEDEX:
            return (waybillNo) =>
                ` https://www.fedex.com/fedextrack/?action=track&trackingnumber=${waybillNo}&cntry_code=cn&locale=zh_cn`;
        case LogisticsCompany.XFWL:
            return (waybillNo) => `http://www.xf-express.com.cn/customer/trace?orderIds=${waybillNo}`;

        case LogisticsCompany.HMZJB:
            return (waybillNo) => `https://www.t-cat.com.tw/Inquire/Trace.aspx?no=${waybillNo}`;
        case LogisticsCompany.DN:
            return (waybillNo) => `https://www.danniao.com/query.html?ids=${waybillNo}`;
        case LogisticsCompany.SXJD:
            return (waybillNo) => `https://www.sxjdfreight.com/service/cargoTracking.html?ewbNo=${waybillNo}`;
        case LogisticsCompany.SZKKE:
            return (waybillNo) => `https://www.szkke.com/c/kuaijianchaxun.html?number=${waybillNo}`;
        case LogisticsCompany.STE56:
            return (waybillNo) =>
                `http://106.55.23.231:8082/SearchScanInfoInterface/searchCode.do?billcode=${waybillNo}`;
        case LogisticsCompany.ANDE:
            return (waybillNo) => `https://www.annto.com/service/order/?orderNoFormMain=${waybillNo}`;
        case LogisticsCompany.EWE:
            return (waybillNo) => `https://www.ewe.com.au/html/track.html?cno=${waybillNo}#track-results`;
        case LogisticsCompany.GJWL:
            return (waybillNo) => `http://www.goldjet.com.cn/html/zaitugenzong/?id=${waybillNo}`;
        case LogisticsCompany.WSKD:
            return (waybillNo) =>
                `http://new.wherexpress.com/index.php?r=personalmanage/assbillnoinfo&AssbillNo=${waybillNo}`;
        case LogisticsCompany.XLOBO:
            return (waybillNo) => `http://www.xlobo.com/Public/QueryBillFlow.aspx?billCode=${waybillNo}`;

        case LogisticsCompany.ZYEHQ:
            return (waybillNo) =>
                `https://t.17track.net/zh-cn#nums=${waybillNo}&fc=190138&utm_source=carriers&utm_medium=referer&utm_campaign=20230130-carrier-open-t`;

        case LogisticsCompany.ZYSF:
            return (waybillNo) =>
                `http://member.transrush.com/Transport/LogisticsTransferTrace.aspx?code=${waybillNo}&vcode=&source=undefined`;

        case LogisticsCompany.KDLL:
            return (waybillNo) => `https://www.kder.com.cn/support?waybillNo=${waybillNo}`;
        case LogisticsCompany.STO:
            return (waybillNo) => `https://www.sto.cn/pc/service-page/iframe_2_21_${waybillNo}`;
        default:
            break;
    }

    return null;
}

function generateKD100Builder(logisticsCompany: LogisticsCompany): UrlBuilder {
    const code = LogisticsCompanyKuaiDi100CodeMap[logisticsCompany];

    if (!code) {
        return null;
    }

    return (waybillNo) => `https://www.kuaidi100.com/all/${code}.shtml?mscomnu=${waybillNo}`;
}

function getBaiduWaybillUrl(waybillNo: string) {
    return `https://www.baidu.com/s?wd=快递单号查询${waybillNo}`;
}

function getSogouWaybillUrl(waybillNo: string) {
    return `https://sogou.com/web?query=快递单号查询${waybillNo}`;
}

/**
 * 快递100小程序qrcode
 */
function generateKD100WxappQrcode(waybillNo: string) {
    return `https://wx.kuaidi100.com/wxbuss.do?method=getWXACodeUnLimit&pagePath=pages/index/index&scene=nu%3D${waybillNo}%26src%3Dw`;
}

function generateBaiduBuilder(logisticsCompany: LogisticsCompany): UrlBuilder {
    switch (logisticsCompany) {
        case LogisticsCompany.ZTO:
        case LogisticsCompany.YUNDA:
        case LogisticsCompany.YUNDA56:
        case LogisticsCompany.YUNDAGJ:
        case LogisticsCompany.YUNDA_DTD:
        case LogisticsCompany.YUNDA_TC:
        case LogisticsCompany.YTO:
        case LogisticsCompany.SF:
        case LogisticsCompany.SFKY:
        case LogisticsCompany.EMS:
        case LogisticsCompany.POST:
        case LogisticsCompany.POSTB:
        case LogisticsCompany.POSTS:
        case LogisticsCompany.JT:
        case LogisticsCompany.STO:
        case LogisticsCompany.STO56:
        case LogisticsCompany.STOGJ:
        case LogisticsCompany.DBKD:
        case LogisticsCompany.DBL:
        case LogisticsCompany.JDKY:
        case LogisticsCompany.JD_EXPRESS:
        case LogisticsCompany.JD_HPCP:
        case LogisticsCompany.BESTQJT:
        case LogisticsCompany.BEST:
        case LogisticsCompany.BESTGJ:
        case LogisticsCompany.UC:
        case LogisticsCompany.ANDE:
        case LogisticsCompany.ANE56:
        case LogisticsCompany.ANE66:
        case LogisticsCompany.DN:
        case LogisticsCompany.EWE:
        case LogisticsCompany.FENGWANG:
        case LogisticsCompany.FEDEX:
        case LogisticsCompany.JYMWL:
        case LogisticsCompany.SZKKE:
        case LogisticsCompany.KUAYUE:
        case LogisticsCompany.LB:
        case LogisticsCompany.LWT:
        case LogisticsCompany.UAPEX:
        case LogisticsCompany.SURE:
        case LogisticsCompany.HOAU:
        case LogisticsCompany.XFWL:
        case LogisticsCompany.YCKY:
        case LogisticsCompany.WTO:
        case LogisticsCompany.YMDD:
        case LogisticsCompany.ZJS:
        case LogisticsCompany.HTKY:
        case LogisticsCompany.EYB:
        case LogisticsCompany.HSYSD:
            return getBaiduWaybillUrl;

        default:
            break;
    }

    return null;
}

function generateSogouBuilder(logisticsCompany: LogisticsCompany): UrlBuilder {
    switch (logisticsCompany) {
        case LogisticsCompany.ZTO:
        case LogisticsCompany.YTO:
        case LogisticsCompany.SF:
        case LogisticsCompany.SFKY:
        case LogisticsCompany.EMS:
        case LogisticsCompany.POST:
        case LogisticsCompany.POSTB:
        case LogisticsCompany.POSTS:
        case LogisticsCompany.JT:
        case LogisticsCompany.STO:
        case LogisticsCompany.STO56:
        case LogisticsCompany.STOGJ:
        case LogisticsCompany.DBKD:
        case LogisticsCompany.DBL:
        case LogisticsCompany.JDKY:
        case LogisticsCompany.JD_EXPRESS:
        case LogisticsCompany.JD_HPCP:
        case LogisticsCompany.BESTQJT:
        case LogisticsCompany.BEST:
        case LogisticsCompany.BESTGJ:
        case LogisticsCompany.UC:
        case LogisticsCompany.EYB:
        case LogisticsCompany.HSYSD:
            return getSogouWaybillUrl;

        default:
            break;
    }

    return null;
}

export function getLogisticsCompanyTrackingBuilderMap() {
    if (init) {
        return LogisticsCompanyTrackingBuilderMap;
    }

    Object.values(LogisticsCompany).forEach((logisticsCompany) => {
        const official = generateOfficialBuilder(logisticsCompany);
        const kd100 = generateKD100Builder(logisticsCompany);
        const bd = generateBaiduBuilder(logisticsCompany);
        const sg = generateSogouBuilder(logisticsCompany);

        if (!LogisticsCompanyTrackingBuilderMap[logisticsCompany]) {
            if (official || kd100 || bd || sg) {
                LogisticsCompanyTrackingBuilderMap[logisticsCompany] = [];
            }
        }

        if (official) {
            LogisticsCompanyTrackingBuilderMap[logisticsCompany].push({
                type: TrackingWaybillType.OFFICIAL,
                builder: official,
            });
        }
        if (kd100) {
            LogisticsCompanyTrackingBuilderMap[logisticsCompany].push({
                type: TrackingWaybillType.KD100,
                builder: kd100,
            });
        }
        if (bd) {
            LogisticsCompanyTrackingBuilderMap[logisticsCompany].push({
                type: TrackingWaybillType.BAIDU,
                builder: bd,
            });
        }
        if (sg) {
            LogisticsCompanyTrackingBuilderMap[logisticsCompany].push({
                type: TrackingWaybillType.SOGOU,
                builder: sg,
            });
        }
    });

    init = true;
    return LogisticsCompanyTrackingBuilderMap;
}

export interface ValidTrackingUrlResult {
    type: TrackingWaybillType;

    url: string;
}

/**
 * 获取一个有效的物流跟踪链接
 */
export function getFirstValidTrackingUrl(
    logisticsCompany: LogisticsCompany,
    waybillNo?: string,
): ValidTrackingUrlResult | null {
    if (!waybillNo || !logisticsCompany) {
        return null;
    }

    const mapping = getLogisticsCompanyTrackingBuilderMap();

    const trackingBuilders = mapping[logisticsCompany];

    for (let i = 0; i < trackingBuilders?.length; i++) {
        const trackingBuilder = trackingBuilders[i];

        trackingBuilder.type;
        const url = trackingBuilder.builder(waybillNo);

        if (url) {
            return {
                type: trackingBuilder.type,
                url,
            };
        }
    }

    return null;
}

/**
 * 获取所有有效的物流跟踪链接
 */
export function getAllValidTrackingUrl(
    logisticsCompany: LogisticsCompany,
    waybillNo?: string,
): ValidTrackingUrlResult[] {
    if (!waybillNo || !logisticsCompany) {
        return [];
    }

    const mapping = getLogisticsCompanyTrackingBuilderMap();

    const trackingBuilders = mapping[logisticsCompany];

    const results: ValidTrackingUrlResult[] = [];

    for (let i = 0; i < trackingBuilders?.length; i++) {
        const trackingBuilder = trackingBuilders[i];

        const url = trackingBuilder.builder(waybillNo);

        if (url) {
            results.push({
                type: trackingBuilder.type,
                url,
            });
        }
    }

    return results;
}

/**
 * 获取所有有效的物流跟踪链接
 */
export function getValidTrackingUrlByType(
    type: TrackingWaybillType,
    logisticsCompany: LogisticsCompany,
    waybillNo?: string,
): ValidTrackingUrlResult | null {
    if (!waybillNo || !logisticsCompany) {
        return null;
    }

    const results = getAllValidTrackingUrl(logisticsCompany, waybillNo);

    if (type === TrackingWaybillType.RANDOM) {
        const result = sample(results);

        return result;
    } else {
        let result = results.find((result) => {
            return result.type === type;
        });

        if (!result) {
            result = results[0];
        }

        return result;
    }
}
